import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-tennis-correct-score',
    templateUrl: './default/tennis-correct-score/tennis-correct-score.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule, PipesModule]
})
export class TennisCorrectScoreComponent extends UnitsDistributionBase {
  // Used for both TENNIS_CORRECT_SCORE_3 and TENNIS_CORRECT_SCORE_5
  // Same component handles both 3-set and 5-set matches
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }

  // Could add methods specific to tennis scoring if needed
  // Example: isThreeSetMatch(): boolean {
  //   return this.leg.type_code === 'TENNIS_CORRECT_SCORE_3';
  // }
}